import * as React from "react";
import {
  renderMenu_unstable,
  useMenuContextValues_unstable,
} from "@fluentui/react-components";
import { useAppMenu } from "./useAppMenu";
import type { AppMenuProps } from "./AppContextualMenu.types";

export const AppMenu = React.forwardRef<HTMLDivElement, AppMenuProps>(
  (props, _ref) => {
    const state = useAppMenu(props);
    const contextValues = useMenuContextValues_unstable(state);
    return (
      <div data-unique-id={props.dataUniqueId}>
        {renderMenu_unstable(state, contextValues)}
      </div>
    );
  }
);
